<template>
  <el-upload
  class="upload-demo"
  ref="upload"
  action="https://jsonplaceholder.typicode.com/posts/"
  :file-list="fileList"
  :on-change="onChange"
  :auto-upload="false">
  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
  <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
</el-upload>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    methods:{
        onSuccess(response,file,fileList){
            // console.log(response)
            // console.log(file)
            // console.log(fileList)
        },
        onChange(file,fileList){
            //             console.log(file)
            // console.log(fileList)
        }
    }
}
</script>

<style>

</style>